$ ->
  require('../components/layout/client.coffee')()
